import { React } from "aaa";

export class A11yRefocus extends React.Component<{
    children: any
    focusId?: any
}, {}> {
    ref: any;

    componentDidMount() {
        if (this.ref) {
            this.ref.focus();
        }
    }

    componentDidUpdate(prevProps: { focusId?: any }) {
        if (this.ref) {
            // Refocus only if focusId changed
            if (this.props.focusId !== prevProps.focusId) {
                this.ref.focus();
            }
        }
    }

    render() {
        return (
            <div
                style={{
                    outline: "none" // needed to avoid orange frame in some browsers
                }}
                tabIndex={-1} // needed to allow focusing
                ref={(c: any) => this.ref = c}
            >
                {...this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/A11yRefocus.tsx